import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleMouseUp = (self, event) => {
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const translate_transforming = self._getTranslateTransformingThrowable();
  const rotate_transforming = self._getRotateTransformingThrowable();
  const scale_transforming1 = self._getScaleTransforming1Throwable();
  if (self._mouse_down_position == null) {
    return;
  }
  const { clientX: client_x, clientY: client_y } = event;
  const mouse_up_point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  switch (self._processing_task) {
    case PROCESSING_TASK.SELECTING: {
      const rubber_band_layer_ctm = rubber_band_layer_el.getCTM();
      if (rubber_band_layer_ctm == null) {
        return;
      }
      const rubber_band_layer_ctm_inverse = rubber_band_layer_ctm.inverse();
      const point = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
        mouse_up_point.x,
        mouse_up_point.y,
      ]).matrixTransform(rubber_band_layer_ctm_inverse);
      rubber_band.endSelecting({
        x: point.x,
        y: point.y,
      });
      self._processing_task = null;
      self._mouse_down_position = null;
      return;
    }
    case PROCESSING_TASK.TRANSLATE_TRANSFORMING: {
      translate_transforming.end();
      self._processing_task = null;
      self._mouse_down_position = null;
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING1: {
      scale_transforming1.end();
      self._processing_task = null;
      self._mouse_down_position = null;
      return;
    }
    case PROCESSING_TASK.ROTATE_TRANSFORMING: {
      rotate_transforming.end();
      self._processing_task = null;
      self._mouse_down_position = null;
      self._rotate_transforming_origin_x = 0;
      self._rotate_transforming_origin_y = 0;
      return;
    }
    case null: {
      self._mouse_down_position = null;
      return;
    }
    default: {
      return;
    }
  }
};
